export default __webpack_public_path__ + "static/media/hht2_home_img_EP10.0412309e.png";